import { Add, Button, Chevron, Dropdown } from '@lmc/ui-kit'
import { MenuProps } from 'antd'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { capitalize } from 'lodash'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SHIFT, VISIT } from 'screens/Rostering/constants'
import { RotaPatternModal } from 'screens/Rostering/RotaPattern'
import { RotaPatternModalType } from 'screens/Rostering/RotaPattern/utils'
import NewRotaPatternModal from 'screens/Rostering/RotaPattern/NewRotaPatternModal/NewRotaPatternModal'

type AddRotaPatternDropdownProps = {
  firstPattern?: boolean
}

export const AddRotaPatternDropdown = ({
  firstPattern,
}: AddRotaPatternDropdownProps) => {
  const { t } = useTranslation()

  const [patternModalType, setPatternModalType] = useState<
    RotaPatternModalType | undefined
  >(undefined)

  const flags = useFeatureFlags({
    flagNames: ['new_create_pattern', 'published_rota'],
  })?.data

  const flagsNewCreatePatternEnabled = flags?.new_create_pattern?.enabled

  const flagsPublishedRotaEnabled = flags?.published_rota?.enabled

  const handleRotaMenuClick: MenuProps['onClick'] = (key) => {
    setPatternModalType(key as any)
  }

  const menuItems = [
    {
      key: VISIT,
      label: firstPattern ? t('ADD_A_VISIT') : capitalize(t('VISIT')),
      'data-intercom-target': 'add-rota-pattern-visit',
    },
    {
      key: SHIFT,
      label: firstPattern ? t('ADD_A_SHIFT') : capitalize(t('SHIFT')),
      'data-intercom-target': 'add-rota-pattern-shift',
    },
  ]

  return (
    <>
      <Dropdown
        menu={{
          items: menuItems,
          onClick: ({ key }) => handleRotaMenuClick(key as any),
        }}
        trigger={['click']}
      >
        <Button
          variant={firstPattern ? 'primary' : 'default'}
          id="add-rota-pattern-dropdown"
          data-cy="btn-add-rota-pattern"
        >
          {flagsPublishedRotaEnabled && !firstPattern ? (
            <>
              <Add /> {t('ADD')}
            </>
          ) : (
            <>
              {t('ADD_ROTA_PATTERN')} <Chevron direction="down" />
            </>
          )}
        </Button>
      </Dropdown>
      {!!patternModalType &&
        (flagsNewCreatePatternEnabled ? (
          <NewRotaPatternModal
            onCancel={() => setPatternModalType(undefined)}
            type={patternModalType as RotaPatternModalType}
          />
        ) : (
          <RotaPatternModal
            patternModalVisible={!!patternModalType}
            onCancel={() => setPatternModalType(undefined)}
            type={patternModalType as RotaPatternModalType}
          />
        ))}
    </>
  )
}
